export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";